module.exports = __webpack_public_path__ + "static/img/ri-question-line.f2459609.svg";